// src/components/UserPopover.tsx

import React from "react";
import {
  Box,
  Popover,
  MenuList,
  MenuItem,
  ListItemIcon,
  Typography,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

// Example icons from @mui/icons-material:
import {
  Logout,
  AccountBalanceWallet,
  Person,
  Discount,
  LocalOffer,
} from "@mui/icons-material";

import { UserContext } from "../../contexts/user-context";
import { authClient } from "../lib/auth/client";
import { paths } from "./paths";

export interface UserPopoverProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
}

export function UserPopover({
  anchorEl,
  open,
  onClose,
}: UserPopoverProps): React.JSX.Element {
  const context = React.useContext(UserContext);
  const user = context?.user;
  const navigate = useNavigate();

  const handleWallet = (): void => {
    onClose();
    navigate(paths.wallet);
  };

  const handleMyOffers = (): void => {
    onClose();
    navigate(paths.myOffers);
  };

  const handleNearMe = (): void => {
    onClose();
    navigate(paths.nearMe);
  };

  const handleProfile = (): void => {
    onClose();
    navigate(paths.profile);
  };

  const handleLogout = async (): Promise<void> => {
    onClose();
    localStorage.clear();
    await authClient.signOut();
    window.location.reload();
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: 240,
          },
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {/* Optional user info header */}
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1">{user?.displayName}</Typography>
        <Typography variant="body2" color="text.secondary">
          {user?.email}
        </Typography>
      </Box>

      <Divider />

      <MenuList sx={{ p: 1, "& .MuiMenuItem-root": { borderRadius: 1 } }}>
        <MenuItem onClick={handleWallet}>
          <ListItemIcon>
            <AccountBalanceWallet />
          </ListItemIcon>
          Wallet
        </MenuItem>
        <MenuItem onClick={handleMyOffers}>
          <ListItemIcon>
            <LocalOffer />
          </ListItemIcon>
          My Offers
        </MenuItem>
        {/*<MenuItem onClick={handleNearMe}>
          <ListItemIcon>
            <Discount />
          </ListItemIcon>
          Deals Near Me
        </MenuItem>*/}
        <MenuItem onClick={handleProfile}>
          <ListItemIcon>
            <Person />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
          <ListItemIcon>
            <Logout sx={{ color: "#f44336" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </MenuList>
    </Popover>
  );
}
